import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailIcon,
  FacebookIcon,
  TwitterIcon,
} from "react-share";

export const FacebookShareIcon = () => {
  return (
    <FacebookShareButton url={window.location.href}>
      <FacebookIcon size={25} round={true} />
    </FacebookShareButton>
  );
};

export const TwitterShareIcon = () => {
  return (
    <TwitterShareButton url={window.location.href}>
      <TwitterIcon size={25} round={true} />
    </TwitterShareButton>
  );
};

export const EmailShareIcon = () => {
  return (
    <a href={`mailto:?body=${window.location.href}`} target="_blank" rel="noopener noreferrer"><EmailIcon size={25} round={true} /></a>
  );
};
